module.exports = __webpack_public_path__ + "img/family-alt.94de1f97.svg";